import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import type { Database } from "@/integrations/supabase/types";

type Escalation = Database["public"]["Tables"]["sentinel_escalations"]["Row"];

interface EscalationInboxProps {
  escalations: Escalation[];
  onAck: (id: string) => void;
}

export function EscalationInbox({ escalations, onAck }: EscalationInboxProps) {
  if (escalations.length === 0) {
    return (
      <Card><CardContent className="py-12 text-center">
        <CheckCircle2 className="w-10 h-10 text-green-500 mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">Nenhuma escalação pendente.</p>
      </CardContent></Card>
    );
  }

  return (
    <div className="space-y-3">
      {escalations.map(esc => {
        const details = esc.details as Record<string, unknown> | null;
        const isAcked = !!esc.ack_at;
        return (
          <Card key={esc.id} className={isAcked ? "opacity-60" : ""}>
            <CardContent className="pt-4 pb-3">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3 min-w-0">
                  <ArrowUpRight className="w-4 h-4 mt-0.5 text-orange-500 shrink-0" />
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <span className="text-sm font-medium">{String(details?.alert_title || "Escalação")}</span>
                      <Badge variant={esc.severity === "critical" ? "destructive" : "secondary"} className="text-xs">{esc.severity}</Badge>
                      <Badge variant="outline" className="text-xs">→ {esc.to_role}</Badge>
                      <Badge variant="outline" className="text-xs">{esc.channel}</Badge>
                    </div>
                    <p className="text-xs text-muted-foreground">{String(details?.alert_message || "")}</p>
                    <p className="text-xs text-muted-foreground mt-1">
                      {esc.delivered_at ? new Date(esc.delivered_at).toLocaleString("pt-BR") : "-"}
                      {isAcked && <span className="text-green-600 ml-2">✓ Reconhecido</span>}
                    </p>
                  </div>
                </div>
                {!isAcked && (
                  <Button size="sm" variant="outline" onClick={() => onAck(esc.id)}>Reconhecer</Button>
                )}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
